var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "8", "offset-lg": "2" } },
                [
                  _c("system-details", {
                    attrs: {
                      system: _vm.system,
                      type: "config",
                      compact: false
                    }
                  }),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("div", { attrs: { id: "system-footer" } }, [
                      _c("h6", [_vm._v(_vm._s(_vm.$t("titles.footer")))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { attrs: { "align-h": "between" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "min-width-button",
                          attrs: {
                            type: "button",
                            variant: "outline-secondary",
                            to: { name: "systems" }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("buttons.back")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "min-width-button",
                          attrs: {
                            type: "button",
                            variant: "outline-secondary",
                            to: {
                              name: "issue-system-config",
                              params: { logosid: this.system.LogosID }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("buttons.continue")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b93d0f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b93d0f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/SystemConfigOverview.vue
// module id = 765
// module chunks = 0